import React from "react";
import { useMsal } from "@azure/msal-react";
import { DefaultButton } from '@fluentui/react/lib/Button';

async function handleLogout(instance, setTokenExpired) {
    setTokenExpired(false);
    await instance.logoutRedirect().catch(e => {
        console.error(e);
    });
}

export const SignOutButton = (props) => {
    const {setTokenExpired} = props;
    const { instance } = useMsal();

    return (
        <DefaultButton text="Sign Out" onClick={() => handleLogout(instance, setTokenExpired)}>Sign out</DefaultButton>
    );
}